import { Facebook, LinkedIn, Twitter, YouTube } from '../../icons'

export const socialData = {
  LinkedIn: {
    url: 'https://www.linkedin.com/company/commonwealth-financial-network/',
    component: LinkedIn,
  },
  Twitter: {
    url: 'https://twitter.com/CommonwealthFN',
    component: Twitter,
  },
  Facebook: {
    url: 'https://www.facebook.com/CommonwealthFinancialNetwork',
    component: Facebook,
  },
  Youtube: {
    url: 'https://www.youtube.com/user/CommonwealthBD',
    component: YouTube,
  },
}
